module.exports = __webpack_public_path__ + "img/share-from-square-sharp-light.07b36cd4.svg";